<template>
    <div class="scrollable-block">
        <div class="main-block request-management">
            <Breadcrumbs />
            <SystemStatistics />
           
        </div>
    </div>
</template>

<script>
import SystemStatistics from "@/view/admin/statistics/SystemStatistics.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
    components: {
        SystemStatistics,
        Breadcrumbs
    },
    data() {
        return {
            activeTab: "user"
        };
    }
};
</script>
<style scoped>
.main-block:not(.chat-page) {
    overflow: hidden;
    min-height: 80vh !important;
}
</style>